// טיפוסים משותפים לעורך, לאשף ולמרכז היצוא.
import type { BannerDoc, BrandKit, Layer } from '@bb/schema';

export interface AssetInfo {
  url: string;
  family?: string;
  weight?: number;
  unicodeRange?: string;
  mime?: string;
  kind?: string;
  name?: string;
}
export type AssetMap = Record<string, AssetInfo>;

export interface Check { code: string; severity: 'error' | 'warning' | 'info'; passed: boolean; message: string; details?: unknown }
export interface GeoIssue { code: string; severity: 'error' | 'warning'; layerIds: string[]; message: string }

export interface Sibling { id: string; width: number; height: number; display_name: string; current_revision: number }

export interface VariantCtx {
  variant: { id: string; banner_set_id: string; placement_id: string; spec_version_id: string; width: number; height: number; display_name: string; banner_key: string; current_revision: number; needs_review?: boolean; needs_review_reason?: string | null };
  set: { id: string; name: string; campaign_id: string };
  campaign: { id: string; name: string; copy: any; default_url: string; client_id: string; language: string };
  revision: { revision: number; doc: BannerDoc; source: string; summary: string; created_at: string } | null;
  spec: { id: string; version: number; status: string; is_demo: boolean; resolved: Record<string, any> } | null;
  kit: BrandKit;
  overridden?: string[];
  placement: { id: string; name: string; placement_key: string };
  site: { id: string; name: string; media_key: string };
  assets: AssetMap;
  siblings: Sibling[];
  issues: GeoIssue[];
}

export type { BannerDoc, Layer };

export const ROLE_LABEL: Record<string, string> = {
  logo: 'לוגו', headline: 'כותרת', subline: 'משנה', cta: 'CTA', image: 'תמונה', background: 'רקע', disclaimer: 'גילוי נאות', decor: 'עיטור',
};
export const TYPE_LABEL: Record<string, string> = { text: 'טקסט', image: 'תמונה', shape: 'צורה', button: 'כפתור' };
export const FAMILY_LABEL: Record<string, string> = { horizontal: 'אופקי', square: 'ריבועי', vertical: 'אנכי', thin: 'דק' };

export const SPEC_STATUS_LABEL: Record<string, string> = { draft: 'טיוטה', pending_approval: 'ממתין לאישור', approved: 'מאושר', superseded: 'הוחלף' };

/** זמן (elapsed) שבו מוצג פריים הסיום — לתמונות ממוזערות */
export function endFrameElapsed(doc: BannerDoc): number {
  if (doc.loops > 0) return doc.durationMs * doc.loops;
  return doc.endFrameMs ?? Math.max(0, doc.durationMs - 1);
}

export function fmtMs(ms: number): string {
  return `${(ms / 1000).toFixed(2)}s`;
}
